import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@material-ui/core';

import Spinner from '../../components/UI/Spinner';
import ButtonBack from '../../components/UI/Buttons/ButtonBack';
import ButtonDownload from '../../components/UI/Buttons/ButtonDownload';
import Aux from '../../hoc/NoParent';

import { loadSettlementFromServer } from '../../store/actions/index';
import dataFormatter from '../../util/dataFormatter';
import { Link } from 'react-router-dom';

class SettlementView extends Component {
    state = {
        downloading: false
    }

    componentDidMount() {
        if(this.props.token && !this.props.error) {
            this.props.onLoadSettlement(this.props.match.params.id, this.props.token);
        }
    }

    render() {
        if(this.props.loading) return <Spinner />;

        if(this.props.error) return <div>Error</div>;

        const { settlement, history } = this.props;

        if(!settlement || !settlement.details) return null;

        let i = 0;
        let totalCheckAmount = 0;
        const checkDate = dataFormatter.toDate(settlement.details[0].check_date);

        const tableDetails = settlement.details.map(detail => {
            totalCheckAmount += (+detail.detail_amount);

            const classNames = ['SettlementDetail'];

            if((+detail.detail_amount) >= 0 && (+detail.detail_amount) <= 0) {
                classNames.push('ZeroDollarPay');
            }

            let orderNumber = detail.order_number;

            if(!!detail.leg_number) {
               orderNumber = <Link to={`/loads/${detail.leg_number}`}>{orderNumber}</Link>;
            }

            return (
                <TableRow className={classNames.join(' ')} key={i++}>
                    <TableCell>{orderNumber}</TableCell>
                    <TableCell className="Date">{dataFormatter.toDate(detail.leg_start_date)}</TableCell>
                    <TableCell className="Origin">{detail.leg_origin}</TableCell>
                    <TableCell className="Destination">{detail.leg_destination}</TableCell>
                    <TableCell className="ItemType">{detail.detail_code_label}</TableCell>
                    <TableCell className="Description">{detail.detail_description}</TableCell>
                    <TableCell align="right">{dataFormatter.toNumber(detail.detail_quantity, 2)}</TableCell>
                    <TableCell className="Rate" align="right">{dataFormatter.toMoney(detail.detail_rate)}</TableCell>
                    <TableCell align="right">{dataFormatter.toMoney(detail.detail_amount)}</TableCell>
                </TableRow>
            );
        });

        let downloadFrame = null;

        if(this.state.downloading) {
            downloadFrame = <iframe title="Download" src={`https://portals.leonardsexpress.com/driver/lite/settlements/download/${this.props.match.params.id}?token=${this.props.token}`} frameBorder="0" style={{width: '1px', height: '1px'}}></iframe>
        }
    
        return (
            <Aux>
                <div>
                    <ButtonBack onClick={(event) => history.push('/settlement')} color="primary" aria-label="Back To Settlements" title="Back To Settlements" />
                    <ButtonDownload onClick={() => this.setState({downloading: true})} color="secondary" aria-label="Download" title="Download" />
                </div>
                <Typography variant="h6">Settlement Sheet {checkDate}</Typography>
                <Table size="small">
                    <TableHead>
                        <TableRow className="SettlementDetail">
                            <TableCell>Order #</TableCell>
                            <TableCell className="Date">Date</TableCell>
                            <TableCell className="Origin">Origin</TableCell>
                            <TableCell className="Destination">Destination</TableCell>
                            <TableCell className="ItemType">Item Type</TableCell>
                            <TableCell className="Description">Description</TableCell>
                            <TableCell>Qty</TableCell>
                            <TableCell className="Rate">Rate</TableCell>
                            <TableCell>Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>{tableDetails}</TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell>Total</TableCell>
                            <TableCell colSpan={8} align="right">{dataFormatter.toMoney(totalCheckAmount)}</TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
                {downloadFrame}
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.settlement.loading, 
        error: state.settlement.error, 
        settlement: state.settlement.selectedSettlement, 
        token: state.auth.token
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadSettlement: (check_id, token) => dispatch(loadSettlementFromServer(check_id, token))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettlementView);